export default __webpack_public_path__ + "static/media/plan-on-an-incident-responce-plan.b21fc4c7.jpg";